import ApiService from "@/plugins/ApiService";
import { SET_LOADING, SET_AUTH_INFO } from "@/store/mutation-types";
import { DISPATCH_CHECKOUT, FETCH_ORDER } from "@/store/action-types";

const state = {
    order: {
        billing_cycle: "",
        amount: 0,
        email: "",
        phone: "",
        country: "",
        password: "",
        first_name: "",
        last_name: "",
        is_business: "",
        company_name: "",
        vat_number: "",
        station_name: "",
        website: "",
        station_timezone: "UTC",
        country: "",
        plan_id: '',
        addons: []
    }
}

const mutations = {
    UPDATE_ORDER(state, data) {
        state.order.splice(data, 1)
    },

    resetOrder(state) {
        Object.keys(state.order).forEach(function(key) {
            state.order[key] = ''
        });
    }
}


const actions = {

    [FETCH_ORDER]({ commit }, { plan, period }) {

        commit(SET_LOADING, true)
        return new Promise((resolve, reject) => {
            ApiService.get(`checkout/${plan}/${period}`)
                .then(response => {
                    commit(SET_LOADING, false)

                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })
        })
    },

    [DISPATCH_CHECKOUT]({ commit }, payload) {

        commit(SET_LOADING, true)
        return new Promise((resolve, reject) => {
            ApiService.send('checkout', 'post', [], payload)
                .then(response => {


                    commit(SET_LOADING, false)
                    commit(SET_AUTH_INFO, response.data)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })

        })
    },

}

export default {
    state,
    mutations,
    actions
}